import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { getSharedCostByDimensionIdThunk } from "@/store/dimensions/thunks/shared-costs/getSharedCostByDimensionIdThunk";

// will find shared costs and update shared amounts depending on category creation or deletion
export const updateSharedCostsOnCategoryCreateOrDeleteThunk = createAsyncThunk(
  "dimensions/updateSharedCostsOnCategoryCreateOrDelete",
  async (
    {
      categoryId,
      dimensionId,
      action,
    }: {
      categoryId?: string;
      dimensionId: string;
      action: "create" | "delete";
    },
    { dispatch },
  ) => {
    const sharedCosts = await dispatch(
      getSharedCostByDimensionIdThunk({ dimensionId, forceRefetch: true }),
    ).unwrap();

    if (!categoryId || !sharedCosts) {
      return;
    }

    const promises = sharedCosts.map((sharedCost) => {
      if (sharedCost.distribution_type === "even") {
        return;
      }

      const shareAmounts = sharedCost.share_amounts ?? [];

      const updatedShareAmounts =
        action === "create"
          ? [...shareAmounts, { category_id: categoryId, share_amount: 0 }]
          : shareAmounts.filter(
              ({ category_id }) => categoryId !== category_id,
            );

      return dispatch(
        cloudChiprApi.endpoints.putUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId.initiate(
          {
            dimensionId,
            sharedCostId: sharedCost.id,
            body: {
              id: sharedCost.id,
              name: sharedCost.name,
              share_amounts: updatedShareAmounts,
              filter_tree: sharedCost.filter_tree,
              distribution_type: sharedCost.distribution_type,
            },
          },
        ),
      ).unwrap();
    });

    await Promise.all(promises);
  },
);
